import { Component } from '@angular/core';
import { AppDataService } from '@go-modules/services/app-data/app-data.service';

// This pulls in the css from the legacy folder
// As we port things over to ngx, this should go away
import 'lti/main.less';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent {
	public constructor (public appDataService: AppDataService) {}
}
